import { type SxProps, type Theme } from '@mui/material'

export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexWrap: 'wrap',
    minWidth: 0
  } satisfies SxProps<Theme>,
  description: {
    marginLeft: 1,
    fontStyle: 'italic',
    fontWeight: 'normal',
    wordBreak: 'break-word'
  } satisfies SxProps<Theme>
}
